module.exports = __webpack_public_path__ + "static/media/tray18.b859c7f4.png";